import p from './training-distribution.vue';

export default p;
